import { useRef, useState } from "react";
import { SlOptions } from "react-icons/sl";
import Check from "../../assets/icons/Group.svg";
import Delete from "../../assets/icons/delete-bin-5-line.svg";
import moment from "moment";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { ReadDataCategory } from "../modals/select-tool";
import { AddDataToolModal } from "../modals/addtoolsmodal";
import { DeleteModal } from "../modals/donemodal";
import useErrorStore from "../../data/stores/errorStore";
import { apiCall } from "../../data/useFetcher";
import { toast } from "react-toastify";
import { useRawdataStore } from "../../data/stores/loggerStore";
import { TableTopSearch } from "./tools-table";

const DataTable = ({ data, usecase, datum, setDatum }: any) => {
	const [openPopup, setOpenPopup] = useState(null);
	const popupRef = useRef(null);
	const togglePopup = id => {
			if (openPopup === id) {
				setOpenPopup(null);
			} else {
				setOpenPopup(id);
			}
		},
		[modal, setModal] = useState(""),
		[editable, setEditable] = useState(null),
		[deleteAble, setDeleteAble] = useState(null),
		options = [
			{
				icon: Check,
				name: "view data",
				color: "#505666",
				action: state => {
					setModal(state);
					setOpenPopup(null);
				},
			},
			{
				icon: Check,
				name: "edit data",
				color: "#505666",
				action: state => {
					setEditable(state);
					setOpenPopup(null);
				},
			},
			{
				icon: Delete,
				name: "remove data",
				color: "#C5292A",
				action: sta => {
					setDeleteAble([sta]);
					setOpenPopup(null);
				},
			},
		],
		navigate = useNavigate();

	let { returnErrors } = useErrorStore(),
		[loading, setLoading] = useState<any>(null),
		{ deleteDynamicLogger } = useRawdataStore();
	const onSubmit = async () => {
		setLoading("delete");

		let { response, errArr, errMsg } = await apiCall({
			type: "delete",
			url: `/api/v1/rawdata${
				usecase === "application-level" ? `/manage-kpis` : ""
			}`,
			data: {
				rawdata: deleteAble?.map((it: any) => {
					return { referencedRawDataId: it?._id };
				}),
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			deleteAble.forEach((element: any) => {
				deleteDynamicLogger(
					element,
					usecase === "application-level" ? `kpidata` : "data"
				);
				deleteDynamicLogger(
					element,
					usecase === "application-level" ? `kpirecent` : "recent"
				);
			});
			setDeleteAble(null);
			return;
		}
		setLoading(false);
		setLoading(false);
	};

	return (
		<div>
			<TableTopSearch
				data={datum}
				setData={setDatum}
				handleDelete={() => {
					setDeleteAble(datum?.docs?.filter((iz: any) => iz?.isChecked));
				}}
			/>
			<table className="table-auto w-full">
				<thead className="grid grid-cols-4 capitalize items-center bg-[#F2FBFF] text-base font-medium text-da-blue-700 h-11 w-full px-8 gap-5">
					<th className="text-left">Category</th>
					<th className="text-left col-span-2">Data</th>
					<th className="text-left">Date added</th>
				</thead>
				<tbody>
					{data?.map((it: any, i: number) => (
						<tr
							key={i}
							className="grid grid-cols-4 capitalize text-left px-8 text-base font-normal text-da-blue-800 items-center bg-transparent border-b border-b-[#eee] gap-5 py-3">
							<td className="h-14 flex gap-4 items-center">
								<input
									type="checkbox"
									name=""
									className="form-checkbox size-5 border border-[#ccc]"
									id={it?._id}
									onChange={e => {
										let dd = datum?.docs;
										let current = it;
										if (e?.target?.checked) {
											current = {
												...current,
												isChecked: true,
											};
										} else {
											current = {
												...current,
												isChecked: false,
											};
										}
										dd = dd?.map((ic: any) =>
											ic?._id === it?._id ? current : ic
										);
										setDatum({ ...datum, docs: dd });
									}}
									checked={it?.isChecked}
								/>
								<span className="text-base font-normal  text-da-blue-800 line-clamp-3 capitalize">
									{it?.category ? it?.category?.toLowerCase() : ""}
									{it?.upperCategory ? (
										<small className="capitalize italic">
											{" "}
											[{it?.upperCategory?.toLowerCase()}]
										</small>
									) : null}
								</span>
							</td>
							<td className=" col-span-2">
								<div className="flex gap-1 max-w-xl overflow-x-auto pb-2">
									{it?.data?.map((item: any, x: number) => (
										<ExpertisePill
											value={item?.title}
											key={x}
											toggleState={
												it?.category?.toUpperCase() === "APPLICATION LEVEL" &&
												["utility/municipal", "regulatory"]?.includes(
													item?.title?.toLowerCase()
												) &&
												usecase !== "application-level"
													? () => {
															navigate("application-level", {
																state: {
																	item,
																	category: it?.category,
																},
															});
													  }
													: null
											}
										/>
									))}
								</div>
							</td>
							<td className=" col-span-1 flex justify-between items-center">
								<span>{moment(it?.createdAt).format("DD-MM-YYYY")}</span>
								<div className="relative">
									<SlOptions
										onClick={() => togglePopup(i)}
										className="cursor-pointer"
										color="#404040"
									/>
									{openPopup === i && (
										<div
											style={{
												boxShadow: "0px 10px 40px 0px #0000001A",
											}}
											className="absolute right-0 top-4 mt-2 p-5 bg-white shadow-lg rounded z-10">
											<div className="space-y-3">
												{options?.map((op, idx) => (
													<button
														key={idx}
														onClick={() => (op?.action ? op?.action(it) : {})}
														ref={popupRef}
														className={`h-9 px-3 whitespace-nowrap ${
															idx === 0 && "bg-[#F4F4F4]"
														} bg-transparent flex gap-3 rounded-lg items-center`}>
														<img src={op?.icon} alt="" className="" />
														<span
															style={{
																color: op?.color,
															}}
															className="font-normal capitalize text-sm">
															{op?.name}
														</span>
													</button>
												))}
											</div>
										</div>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{modal && (
				<ReadDataCategory
					handleClose={() => setModal("")}
					defaultSelection={modal}
				/>
			)}
			{editable && (
				<AddDataToolModal
					handleClose={() => setEditable(null)}
					title={`Update ${editable?.category || ""} data`}
					subtitle="Update data"
					sample={editable}
					processInner={usecase}
				/>
			)}
			{deleteAble && (
				<DeleteModal
					page={"Data"}
					close={onSubmit}
					handleClose={() => setDeleteAble(null)}
					path={"/tools"}
					loading={loading === "delete"}
				/>
			)}
		</div>
	);
};

export default DataTable;

export const ExpertisePill = ({ value, state, toggleState, css, bg }: any) => {
	return (
		<div
			className={`px-4 border border-gray-300 rounded-full whitespace-nowrap text-sm flex items-center justify-center capitalize py-2 text-center cursor-pointer h-fit ${css} ${
				state ? "bg-main text-white" : `text-gray ${bg}`
			} flex items-center gap-2`}
			onClick={toggleState}>
			{value}{" "}
			{toggleState ? (
				<span className=" rounded-full border">
					<Icon icon="oi:info" className="" />
				</span>
			) : null}
		</div>
	);
};